import React from "react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import WhatsAppFab from "@/components/site/WhatsAppFab";
import { Toaster } from "@/components/ui/sonner";

export default function SiteLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-bone">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <WhatsAppFab />
      <Toaster position="top-center" richColors />
    </div>
  );
}
